import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { tiposCondicoesPagamento } from '../../../../home/condicao-pagamento/tipo/condicao-pagamento-tipo';

@Component({
  selector: 'sgt-novo-condicao-pagamento-tipo-multiselect',
  templateUrl: './novo-condicao-pagamento-tipo-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCondicaoPagamentoTipoMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoCondicaoPagamentoTipoMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() tipos: number[];
  @Output() tiposChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os tipos',
    plural: 'Tipos',
    singular: 'Tipo',
    searchEmptyResultMessage: 'Nenhum tipo encontrado',
    showFooter: false
  };

  options: IOption[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = tiposCondicoesPagamento.map((tipo) => ({
      id: tipo.id,
      label: tipo.nome
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.tipos = newValue;
  }

  onSearch() {
    this.tiposChange.emit(this.tipos);
  }

  onSelectionChange() {
    this.emitChange(this.tipos);
    this.markAsTouched();
  }
}
